<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle1"><a id="page_xvii"></a><strong>Five Days<br/>in London</strong><br/>May 1940 <a id="page_xviii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?1592e822